import React from 'react';

function Link({ facetItem }) {
    const { url, value, name } = facetItem;

    return (
        <a href={url} className={`sfr-facet-link ${value ? 'sfr-facet-link--active' : ''}`}>
            {name}
        </a>
    );
}

export { Link };
